export default __webpack_public_path__ + "static/media/feature-icon-04.16c647da.svg";